import $ from 'jquery';
import menus from './menus';
import navDropdowns from './navDropdowns';
import navMenus from './navMenus';
import mobileMenu from './mobileMenu';
import headroomInit from './headroomInit';
import { announcementInit } from './announcements';
import themeEditor from './themeEditor';

const Header = () => {

  menus();
  navDropdowns();
  navMenus();
  mobileMenu();
  headroomInit();
  themeEditor();

  $('[data-announcements-carousel]').each((i, carousel) => {
    announcementInit($(carousel));
  });

  // Reinit headroom when crossing over between 'desktop' and 'mobile' (really going from tablet to laptop or vise versa)
  let previous_breakpoint = window.theme.breakpoints.current;

  $(window).on('breakpointChange', (e, breakpoint) => {
    if ((breakpoint === 'mobile' || breakpoint === 'tablet') && (previous_breakpoint === 'mobile' || previous_breakpoint === 'tablet')) { return; }
    
    headroomInit();
    previous_breakpoint = breakpoint;
  });
};

export { Header };